import {Injectable, InjectionToken} from "@angular/core";
import {DxAuthStrategyType} from "./dx-auth-stategy-type";
import {DxAuthStorageStrategyType} from "./dx-auth-storage-strategy-type";
import {DxLogoutStrategyType} from "./dx-logout-strategy-type";


@Injectable()
export class DxAuthConfig {
  /**
   *   АХТУНГ! Эти настройки не вынесенны в env, так как это вопросы,
   *   касающиеся архитектуры приложения а не настроек среды развертывания,
   *   фиксируемых во время билда.
   */
  public authStrategyType: DxAuthStrategyType;
  public authStorageStrategyType: DxAuthStorageStrategyType;
  public logoutStrategyType: DxLogoutStrategyType;
  public loginRout: string;
  public logoutRout: string;
  public env?: any;

  constructor(config: Partial<DxAuthConfig>) {
    this.authStrategyType = config.authStrategyType;
    this.authStorageStrategyType = config.authStorageStrategyType;
    this.logoutStrategyType = config.logoutStrategyType;
    this.loginRout = config.loginRout;
    this.logoutRout = config.logoutRout;
    this.env = config.env;
  }
}

export const DX_AUTH_CONFIG = new  InjectionToken<DxAuthConfig>('DX_AUTH_CONFIG');
